import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaPlanoSelecionadoMatricula = (): TabelaColuna => ({
  Chave: 'PlanoSelecionadoMatricula',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Plano Pagamento Matrícula</div>
  )
})
